<template>
    <div class="home">
        <div class="domain">
            <h3>{{ $t('最新公告') }}</h3>
            <div class="notice-container">
                <div class="notice-title pc">
                    <div @click="selectNotice(item.id,'pc')" :class="{'native' : noticeId == item.id}" v-for="item in noticeList" :key="item.id" class="notice-title-text">{{item.title}}</div>
                </div>
                <div class="notice-title h5">
                    <div @click="selectNotice(item.id, 'h5')" :class="{'native' : noticeId == item.id}" v-for="item in noticeList" :key="item.id" class="notice-title-text">{{item.title}}</div>
                </div>
                <div class="notice-content">
                    <div class="notice-content-title">
                        {{noticeTitle}}
                    </div>
                    <div v-html="noticeContent" class="notice-info"></div>
                </div>
            </div>
        </div>

    </div>
</template>

<script lang="ts" setup>
import {ref} from 'vue';
import { getNoticeList, postNoticeInfo } from "@/api";
import {useRouter} from "vue-router";
const router = useRouter();

const noticeList = ref<any>([]);
const noticeId = ref<number>(0);
const noticeTitle = ref<string>('');
const noticeContent = ref<string>('');
const timeID = setInterval(() => {
    if (sessionStorage.getItem('domain')) {
        getNotice();
        clearTimeout(timeID)
    }
},200)
// fetch('/notice.json').then((response) => response.json())
//     .then((json) => {
//         noticeList.value = json.noticeArr;
//     })
// 获取公告列表
const getNotice = async  () => {
    const params = {
        page: 1,
        pageSize: 20
    }
    const result =  await getNoticeList(params);
    if (result.data?.data) {
        const data = result.data?.data;
        noticeList.value = noticeList.value.concat(data.noticeInfoList);
        noticeList.value.sort((a:any,b: any) => {
            return b.id - a.id;
        })
        noticeId.value = noticeList.value[0].id;
        if (noticeId.value && noticeId.value > 0) {
            await selectNoticeInfo();
        } else {
            for (let i = 0; i < noticeList.value.length; i++) {
                const el = noticeList.value[i];
                if (el.id === noticeId.value) {
                    noticeTitle.value = el.title;
                    noticeContent.value = el.content;
                }
            }

        }

    }
}

const selectNotice = (id: number,str: string) => {
    if (noticeId.value === id) return;
    if (str === 'h5') {
        router.push({
            name: 'NoticeInfo',
            params: {
                id
            }
        });
    } else {
        noticeId.value  = id;
        if (noticeId.value && noticeId.value > 0) {
            selectNoticeInfo();
        } else {
            for (let i = 0; i < noticeList.value.length; i++) {
                const el = noticeList.value[i];
                if (el.id === noticeId.value) {
                    noticeTitle.value = el.title;
                    noticeContent.value = el.content;
                }
            }

        }
    }
}
// 获取公告详情
const selectNoticeInfo = async  () => {
    const params = {
        id: noticeId.value
    }
    const result =  await postNoticeInfo(params);

    if (result.data?.data) {
        const data = result.data?.data.noticeInfo;
        noticeTitle.value = data.title;
        noticeContent.value = data.content;

    }
}



</script>

<style lang="scss" scoped>
.home {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    .domain {
        width: 1200px;
        margin-bottom: 50px;
        h3 {
            font-size: 24px;
            text-align: center;
            margin-bottom: 50px;
            font-weight: 600;
        }
        .domain-list {
            font-size: 16px;

            .click-copy {
                font-size: 14px;
                text-align: center;
            }
            .vpn {
                margin-top: 15px;
                font-size: 14px;

                a{
                    color: #19bca0;
                }
            }
            ul {
                margin-top: 20px;
                display: flex;
                justify-content: space-between;
                li {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    position: relative;
                    .copy-success {
                        position: absolute;
                        background-color: rgba(0,0,0,.6);
                        color: #fff;
                        font-size: 12px;
                        padding: 5px 10px;
                        -webkit-border-radius: 4px;
                        -moz-border-radius: 4px;
                        border-radius: 4px;
                        right: 0;
                        display: none;

                        &.isCopySuccess {
                            display: block;
                        }
                    }
                    &.copyLink {
                        cursor: pointer;
                        color: #19bca0;
                    }

                    .download-link {
                        padding: 10px 20px;
                        background-color: rgba(25, 188, 160, 1);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 5px;
                        color: #fff;
                        margin-top: 10px;
                        position: relative;
                        svg {
                            width: 20px;
                            font-size: 18px;
                            margin-right: 10px;
                        }
                        .android-qr-code {
                            z-index: 2;
                            display: none;
                            width: 160px;
                            position: absolute;
                            top: 50px;
                            -webkit-border-radius: 8px;
                            -moz-border-radius: 8px;
                            border-radius: 8px;
                        }
                        &:hover {
                            .android-qr-code {
                                display: block;
                            }
                        }
                    }
                }
            }
        }

        .notice-container {
            display: flex;
            .notice-title {
                width: 200px;
                height: 600px;
                overflow: scroll;
                background-color: #fff;
                -webkit-border-radius: 8px;
                -moz-border-radius: 8px;
                border-radius: 8px;
                box-shadow: 4px 4px 4px 4px rgba(0, 0, 0, 0.06);
                padding: 15px;

                &.pc {
                    display: block;
                }
                &.h5 {
                    display: none;
                }

                .notice-title-text {
                    margin-bottom: 15px;
                    cursor: pointer;
                    color: rgba(96, 98, 102, 1);
                    &:hover {
                        color: #000;
                        font-weight: 500;
                    }
                    &.native {
                        color: #000;
                        font-weight: 500;
                    }
                }
            }
            .notice-content {
                display: block;
                padding: 15px;
                margin-left: 30px;
                flex: 1;
                min-height: 600px;
                background-color: #fff;
                -webkit-border-radius: 8px;
                -moz-border-radius: 8px;
                border-radius: 8px;
                box-shadow: 4px 4px 4px 4px rgba(0, 0, 0, 0.06);

                .notice-content-title {
                    font-size: 20px;
                    color: #000;
                    font-weight: 500;
                    margin-bottom: 30px;
                }

                .notice-info {
                    font-size: 14px;
                    a {
                        color: #19bca0;
                    }
                    h2 {
                        font-size: 20px;
                        margin-bottom: 10px;
                    }
                    p {
                        margin-bottom: 15px;
                    }
                }
            }
        }
    }
}

@media (max-width: 1200px) {
    .home {
        .domain {
            width: 100%;
            .domain-list {
                ul {
                    flex-direction: column;
                    margin-top: 0;
                    li {
                        margin-bottom: 10px;
                    }
                }
            }
            h3 {
                margin-bottom: 30px;
            }
            .vpn {
                padding: 0 15px;
            }
            .notice-container {
                padding: 0 15px;
                flex-direction: column;

                .notice-title {
                    width: 100%;
                    height: auto;
                    &.pc {
                        display: none;
                    }
                    &.h5 {
                        display: block;
                    }
                }
                .notice-content {
                    margin-left: 0px;
                    margin-top: 15px;
                    display: none;
                    .notice-info {
                        img {
                            width: 100%;
                        }
                    }
                }
            }
        }

    }
}
</style>